import Ajax from './Ajax';

function fetchFile(url, {fileName}, opts) {
    
    // we expect every parameter to be valid, so we do not need to validate parameters 
    return Ajax.promise_json(url + "/" + fileName, {data: {}})
}


export default fetchFile;